export const economicsConstants = {
  UPDATE_ECONOMIC: '[Economics] Update',
  REMOVE_ECONOMIC: '[Economics] Remove',
  LOADING_ECONOMICS: '[Economics] Loading',
  LOADING_ECONOMICS_ERROR: '[Economics] Loading error',
  ECONOMICS_AJAX_CALL: '[Economics] Ajax call',
  ECONOMICS_AJAX_SUCCESS: '[Economics] Ajax success',
  ECONOMICS_AJAX_FAILURE: '[Economics] Ajax error'
}
